var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducator = function SvgEducator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "educator_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 300 300"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".educator_svg__st2{fill:#784aca}.educator_svg__st3{fill:#89bff8}.educator_svg__st4{fill:#2d95f3}.educator_svg__st5{fill:none;stroke:#043673;stroke-width:6;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    style: {
      fill: "#2da75f"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "educator_svg__SVGID_1_",
    cx: 150,
    cy: 150,
    r: 150
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "educator_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#educator_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#educator_svg__SVGID_2_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.6 254.7c6.4-6.4-.4-18.1 6.7-27 12.7-15.9 30-3.5 31.9-16.1 1.5-9.8-9.8-28.1-6.1-36.5 5.1-11.6 17.8-8.2 21.9-14.8 3.1-5 .6-13.3-7.1-31-7.4-17.1 8.8-26.6-2.3-36.1-4-3.4-25.8-5.2-28.5-13.3-3.2-9.7 3.9-30-10.3-38-7.2-4.1-18.7 4-29.4 3.2-23-1.7-19.7-22.3-34.3-24.1-14.5-1.8-22.9 18.7-33.5 15.9s-17.8-26.6-37.1-6.4c-7 7.3-7.8 17.3-11.2 19.5-6 3.8-13.1-4-26.3-1.5-17.9 3.3-1.3 25.2-9.5 36.3-6.8 9.1-21 6-21.2 16.5-.3 13 9 8.8 16 27.7S14 153 32 166.7c22.7 17.3 2.3 26.9 12.1 44.9 5 9.3 28.5 5.9 34.5 14.9 13.6 20.6 8.5 27.8 29.6 33.4 18.3 4.9 48.9 7.8 65.9-.7 11.3-5.6 31.2 9.9 45.5-4.5",
    className: "educator_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 234.8h-84.2v26.6c.2 11.8-1.7 22-4.9 30.8 14.9 5 30.9 7.7 47.6 7.7 16.5 0 32.4-2.7 47.3-7.6-3.2-8.7-5.1-19-4.9-30.9z",
    className: "educator_svg__st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m192.5 260.6-.8-25.8h-84.2v25.4c10.8 11.8 25 18.8 42.7 18.8 17.5 0 31.6-6.8 42.3-18.4",
    className: "educator_svg__st4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1 172.4c0 48.7-34.2 89.5-67.1 89.5-35.2 0-67.1-40.8-67.1-89.5s21.6-88.1 67.1-88.1 67.1 39.4 67.1 88.1",
    className: "educator_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.2 114.6s-22.3-16.7-64.3 23.4c-27.9 26.6-53.7 23.1-65.1 22l-.3-38.4 54.4-41.4 46.2 3.1z",
    className: "educator_svg__st2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m150 225.4-21.5-12.3c-.2 1.2-.3 2.4-.3 3.7 0 12.1 9.8 21.9 21.9 21.9s21.9-9.8 21.9-21.9c0-1.3-.1-2.5-.3-3.7z",
    className: "educator_svg__st4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.7,
    cy: 168.4,
    r: 26.5,
    className: "educator_svg__st5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.3,
    cy: 168.4,
    r: 26.5,
    className: "educator_svg__st5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.8 168.4h-15.6",
    className: "educator_svg__st5"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "educator_svg__SVGID_3_",
    cx: 150,
    cy: 150,
    r: 150
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "educator_svg__SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#educator_svg__SVGID_3_",
    style: {
      overflow: "visible"
    }
  })));
};
export default SvgEducator;